export const isIpv6Cidr = (cidr: string): boolean => {
  if (cidr.indexOf('/') === -1) {
    return false;
  }
  const [ipPart, subnetPart] = cidr.split('/');
  const ipSubParts = ipPart.split(':');
  if (
    ipSubParts.length > 8 ||
    ipSubParts.length < 3 ||
    (ipSubParts.length !== 8 && ipPart.indexOf('::') === -1) ||
    ipSubParts.find((part) => {
      return (
        part.length > 4 ||
        (part !== '' && isNaN(parseInt(part, 16))) ||
        parseInt(part, 16) < 0 ||
        parseInt(part, 16) > 0xffff
      );
    })
  ) {
    return false;
  }
  return !(subnetPart && (parseInt(subnetPart) > 128 || parseInt(subnetPart) < 0));
};

export const isIpv4Cidr = (cidr: string): boolean => {
  if (!/^(\d{1,3}\.){3}\d{1,3}\/\d{1,2}$/.exec(cidr)) {
    return false;
  }
  const [ipPart, subnetPart] = cidr.split('/');
  const ipSubParts = ipPart.split('.');
  if (
    ipSubParts.length !== 4 ||
    ipSubParts.find((part) => {
      return part.length > 3 || isNaN(parseInt(part)) || parseInt(part) < 0 || parseInt(part) > 255;
    })
  ) {
    return false;
  }
  return !(subnetPart && (parseInt(subnetPart) > 32 || parseInt(subnetPart) < 0));
};

export const isCidr = (cidr: string): boolean => {
  return isIpv4Cidr(cidr) || isIpv6Cidr(cidr);
};
